var authListener = {
    authButton: {},
    modal: {},

    init: function ()
    {
        this.authButton = $("[data-target='#loginModal']");
        this.checkAuth('set');
        this.authButton.on('click', function (e) {
            authListener.checkAuth('redirect');
        })
    },
    checkAuth: function (action) {
        $.ajax({
            url: API.URL.AUTH_CHECK,
            type: 'GET',
            data: {},
            beforeSend: function() {},
            complete: function() {},
            success: function( data ) {
                var redirect = data.redirect;
                if (redirect) {
                    if (action === 'redirect') {
                        document.location.href = redirect;
                    } else {
                        authListener.disableAuth();
                    }
                } else {
                    authListener.enableAuth();
                }
            },
            dataType: "json"
        });
    },
    enableAuth: function () {
        authListener.authButton.attr('data-toggle', 'modal');
    },
    disableAuth: function () {
        authListener.authButton.attr('data-toggle', '---modal---');
    },
};

$(function () {
    authListener.init();
});